const admkp = 'add-to-marketplace';
const vwmkp = 'view-marketplace';
const yrmkp = 'your-market-place';

export default {
  options: {
    MarketPlaceMenu: {
      id: 'mkpmenu',
      name: 'Market Place',
      groups: [
        {
          id: 'group1',
          title: '',
          buttons: [
            {
              id: admkp,
              command: admkp,
              markup: '',
              title: 'Add to Marketplace',
              icon: 'addtomarketplace'
            },
            {
              id: vwmkp,
              command: vwmkp,
              markup: '',
              title: 'View Marketplace',
              icon: 'viewmarketplace'
            }
          ]
        }
      ]
    },
    secondmenu: {}
  }
};
